module.exports = __webpack_public_path__ + "static/media/bluesign-logo.9371a402.png";